export default __webpack_public_path__ + "static/media/icon-paper.8b57a6b1.svg";